import { Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAccount } from "@/contexts/account.context";

interface AccountSelectorProps {
  className?: string;
  onOpen?: () => void;
}

const AccountSelector: React.FC<AccountSelectorProps> = ({
  className = "",
  onOpen,
}) => {
  const { selectedAccount, accounts, loading, isAgencyUser, isTeamScoped } =
    useAccount();

  if (loading) {
    return (
      <Button
        variant="outline"
        disabled
        className={`w-full justify-between border-border/60 bg-background hover:bg-muted/50 ${className}`}
      >
        <div className="flex items-center gap-2">
          <Building2 className="h-4 w-4 text-muted-foreground" />
          <span className="text-sm">Carregando contas...</span>
        </div>
        <div className="h-4 w-4 animate-spin rounded-full border-2 border-muted-foreground/30 border-t-muted-foreground" />
      </Button>
    );
  }

  if (accounts.length === 0) {
    return (
      <Button
        variant="outline"
        disabled
        className={`w-full justify-center border-dashed border-border/60 bg-muted/20 text-muted-foreground ${className}`}
      >
        <div className="flex items-center gap-2">
          <Building2 className="h-4 w-4" />
          <span className="text-sm">
            {isTeamScoped ? "Nenhuma loja no seu time" : "Nenhuma conta cadastrada"}
          </span>
        </div>
      </Button>
    );
  }

  if (!selectedAccount) {
    return (
      <Button
        variant="outline"
        onClick={onOpen}
        className={`w-full justify-between border-border/60 bg-background hover:bg-muted/50 transition-colors ${className}`}
      >
        <div className="flex items-center gap-3 truncate">
          <div className="flex items-center justify-center w-8 h-8 bg-[#2869C1]/10 rounded-md">
            <Building2 className="h-4 w-4 text-[#2869C1]" />
          </div>
          <div className="flex flex-col items-start truncate min-w-0 flex-1">
            {/* <M-214> "Conta Principal" é a da agência. Para o lojista, não escolher
                ainda não é um lugar onde se fica — é o convite a escolher. */}
            <span className="text-xs text-muted-foreground font-medium">
              {isAgencyUser ? "Conta Principal" : "Nenhuma conta escolhida"}
            </span>
            <span className="font-semibold text-foreground truncate">
              {isAgencyUser
                ? "Gerenciar contas da Agência"
                : "Selecionar uma conta"}
            </span>
          </div>
        </div>
      </Button>
    );
  }

  return (
    <Button
      variant="outline"
      onClick={onOpen}
      className={`w-full justify-between border-border/60 bg-background hover:bg-muted/50 transition-colors ${className}`}
    >
      <div className="flex items-center gap-3 truncate">
        <div className="flex items-center justify-center w-8 h-8 bg-[#2869C1]/10 rounded-md">
          <Building2 className="h-4 w-4 text-[#2869C1]" />
        </div>
        <div className="flex flex-col items-start truncate min-w-0 flex-1">
          <span className="text-xs text-muted-foreground font-medium">
            {isTeamScoped ? "Loja selecionada" : "Conta selecionada"}
          </span>
          <span className="font-semibold text-foreground truncate">
            {selectedAccount.name}
          </span>
        </div>
      </div>
    </Button>
  );
};

export default AccountSelector;
